export function appendIfExists(key, value, formData) {
  // Image fields should only send File objects, never URL strings
  const imageFields = ['BackgroundImage', 'Image', 'OverlayInputFile', 'PreviewBackgroundImage', 'Preview2n8', 'Preview4n10', 'WatermarkImage', 'CakeMaskPathDefinition', 'BleedMaskPathDefinition'];
  if (imageFields.includes(key)) {
    // TO DELETE - Debug logging
    console.log('appendIfExists - Image field:', key, 'value type:', typeof value, 'is File?', value instanceof File, 'value:', value);
    // TO DELETE - End debug logging
    
    if (!(value instanceof File)) {
      // Skip non-File values for image fields (e.g., URL strings from server)
      // TO DELETE - Debug logging
      console.log('  -> SKIPPING (not a File)');
      // TO DELETE - End debug logging
      return;
    }
  }
  
  // eslint-disable-next-line
  if (value !== null && value !== undefined && value !== 'undefined' && value !== 'null' && value !== '') {
    formData.append(key, value);
  }
}

// YYYY-MM-DD hh:mm:ss
export function convertDateTime(date) {
  return `${date.getFullYear()}-${padTime(date.getMonth())}-${padTime(date.getDate())} ${padTime(date.getHours())}:${padTime(date.getMinutes())}:${padTime(date.getSeconds())}`;
}

export function getCurrentDateAndTime() {
  return convertDateTime(new Date());
}

function padTime(value) {
  return value.toString().substring(0, 2).padStart(2, '0');
}

export function getPreviewImage(url, index) {
  if (!url || !url.trim()) {
    return '';
  }

  if (url.startsWith('blob')) {
    return url;
  }

  if (!index || !index.trim()) {
    return url;
  }

  try {
    const date = new Date(index);
    return `${url}?${date.getTime()}`;
  } catch (error) {
    return `${url}?${index}`;
  }
}

export function getItemFormData(item) {
  const formData = new FormData();
  
  // TO DELETE - Debug logging
  console.log('getItemFormData - Processing keys:', Object.keys(item));
  // TO DELETE - End debug logging
  
  Object.keys(item).forEach(key => {
    // Skip URL fields - they're only for preview display
    if (key.endsWith('Url')) {
      // TO DELETE - Debug logging
      console.log('Skipping URL field:', key);
      // TO DELETE - End debug logging
      return;
    }
    
    // Skip fields marked as preview only
    if (item[key].isPreviewOnly) {
      // TO DELETE - Debug logging
      console.log('Skipping preview-only field:', key);
      // TO DELETE - End debug logging
      return;
    }
    
    if (item[key].values) {
      item[key].values.forEach(value => appendIfExists(`${key}[]`, value, formData));
    } else {
      appendIfExists(key, item[key].value, formData);
    }
  });
  
  // TO DELETE - Debug logging
  console.log('getItemFormData - Final FormData entries:');
  for (let [key, value] of formData.entries()) {
    console.log('  ', key, ':', value instanceof File ? `File: ${value.name}` : value);
  }
  // TO DELETE - End debug logging
  
  return formData;
}

export async function readTextFileContents(file) {
  if (file) {
    let result = await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = function (e) {
        resolve(e.target.result);
      };
      reader.readAsText(file);
    });
    return result;
  }
  return '';
}
